export default __webpack_public_path__ + "static/media/website_development.a0c36a88.jpg";